import React from "react";
import logo from "../../../img/youtube.svg";

export const YouTubeLogo = () => (
    <div className="social youtube">
        <img src={logo} alt="YouTube" />
    </div>
);
